import store from './store'
import router from './router'
import Firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/functions'
import 'firebase/compat/storage'

const config = JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG);
let redirectUrl;

if(process.env.NODE_ENV === "production") {
  redirectUrl = 'https://whycare.health/log-in';
}
// staging has both NODE_ENV production and Vue_APP_ENV, so this overwrites and must come 2nd
if(process.env.VUE_APP_ENV === "staging") {
  redirectUrl = 'https://whycare-staging.web.app//log-in';
}
if(process.env.NODE_ENV === "development" || process.env.VUE_APP_ENV === "test") {
  redirectUrl = "http://localhost:8080/log-in"
}

// via https://medium.com/@MichalBujalski/reactive-firebase-auth-with-vue-92577ab78ff6
export default {
  install: (Vue) => {
    //  store as global properties for easy access
    Vue.firebase = Firebase.initializeApp(config)
    Vue.auth = Vue.firebase.auth()
    Vue.firestore = Vue.firebase.firestore()
    Vue.functions = Vue.firebase.functions()
    Vue.storage = Vue.firebase.storage()

    // init firebase emulators
    // console.log('node env',process.env.NODE_ENV)
    if (location && location.hostname === "localhost" && process.env.VUE_APP_ENV === "test") {
    // initialize emulators for local development when not running on npm localhost
    // if (location.hostname === "localhost" && location.port !== '8080') {
      // auth must use url format
      Vue.auth.useEmulator("http://localhost:9099");
      // firestore must use separate host & port format
      Vue.firestore.useEmulator("localhost", 8081);
      Vue.functions.useEmulator("localhost", 5001);
      Vue.storage.useEmulator("localhost", 9199);
      // allow Cypress to connect to Firestore:
        // https://github.com/cypress-io/cypress/issues/6350
      Vue.firestore.settings({
        experimentalForceLongPolling: true,
        merge: true
      });
    }
    Vue.phoneAuthProvider = new Firebase.auth.PhoneAuthProvider();

    const redirectSettings = {
      url: redirectUrl
    }
    Vue.prototype.$firebase = {
      logIn: async (email, password) => {
        return await Vue.auth.signInWithEmailAndPassword(email, password)
          .catch((err) => {
            // console.log(err);
            if (err.code == 'auth/multi-factor-auth-required') {
              console.log('start phone MFA process', err.resolver);
              // default to using phone for MFA, do not prompt user to choose method
              if(err.resolver && err.resolver.hints && err.resolver.hints.some(hint => hint.factorId == 'phone')) {
                return err;
              } else {
                console.error('no phone auth factor found');
                return err.code;
              }
            }
            return err;
          });
      },
      sendPhoneVerification: async (phoneInfoOptions, recaptchaVerifier) => {
        // Send SMS verification code.
        return Vue.phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier)
          .then((verificationId) => {
            // verificationId will be needed for sign-in completion.
            return verificationId;
          })
          .catch(err => {
            console.error('verifyPhoneNumber error',err.message);
            return err;
          });
      },
      signInWithPhoneCode: async (resolver, verificationId, verificationCode) => {
        var cred = Firebase.auth.PhoneAuthProvider.credential(verificationId, verificationCode);
        var multiFactorAssertion = Firebase.auth.PhoneMultiFactorGenerator.assertion(cred);
        // Complete sign-in. This will also trigger the Auth state listeners.
        return resolver.resolveSignIn(multiFactorAssertion)
          .then((userCredential) => {
            // console.log({userCredential});
            console.log('logged in with MFA successfully');
            return true;
          })
          .catch(err => {
            console.error('resolveSignIn error',err.message);
            return err;
          });
      },
      logOut: async () => {
        return await Vue.auth.signOut()
          .then(() => {
            store.dispatch('resetState');
            router.push('/log-in')
          })
          .catch((err) => {
            // console.log(err);
            return err
          });
      },
      // signUp: async (email, password) => {
      //   let uid;
      //   return await Vue.auth.createUserWithEmailAndPassword(email, password)
      //     // after user created, send email verification
      //     .then(userCredential => {
      //       uid = userCredential.user.uid;
      //       // console.log("practice user saved",uid);
      //     })
      //     .catch((err) => {
      //       // console.log(err);
      //       return err
      //     });
      // },
      resetPassword: async (email) => {
        // console.log(resetPasswordRedirectSettings)
        return await Vue.auth.sendPasswordResetEmail(email, redirectSettings)
          .then(() => {
            return true
          })
          .catch((err) => {
            // console.log(err);
            return err
          });
      },
      verifyEmail: async () => {
        let user = Vue.auth.currentUser;
        return await user.sendEmailVerification(redirectSettings)
          .then(() => {
            // console.log("email sent");
            return true
          })
          .catch((err) => {
            // console.log(err);
            return false
          });
      },
    }
    Vue.auth.onAuthStateChanged( async user => {
      // console.log('USER',user)
      store.dispatch('updateUser', user);
      if(user) {
        let userPropsRef = Vue.firestore.collection('users').doc(user.uid);
        store.dispatch('setUserPropsRef', userPropsRef);

      }
    })
  }
}
